import React, { useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import './CompartilharFeedback.css';

const MENSAGENS_AGRADECIMENTO = [
  'Você acabou de fortalecer o comércio local! 💜',
  'Obrigado por apoiar quem é daqui! 🏘️✨',
  'Cada compartilhamento faz a diferença! 🌟',
  'Você ajudou um negócio local a crescer! 💚',
  'Nossa cidade agradece! 🙌💜',
  'Juntos fortalecemos nossa cidade! 🤝🌟',
];

const SUBTITULO_POR_METODO = {
  native: 'Compartilhado com sucesso!',
  clipboard: 'Link copiado! Cole onde quiser 📋',
  whatsapp: 'Abrindo WhatsApp para compartilhar...',
};

/**
 * Banner flutuante de agradecimento após compartilhamento.
 * Auto-fecha em 4s e dispara confetti animado. Renderizado via portal.
 */
export default function CompartilharFeedback({ visivel, metodo, onFechar }) {
  const mensagem = useMemo(
    () => MENSAGENS_AGRADECIMENTO[
      Math.floor(Math.random() * MENSAGENS_AGRADECIMENTO.length)
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visivel],
  );

  useEffect(() => {
    if (!visivel) return undefined;
    const t = setTimeout(onFechar, 4000);
    return () => clearTimeout(t);
  }, [visivel, onFechar]);

  if (!visivel || typeof document === 'undefined') return null;

  const subtitulo = SUBTITULO_POR_METODO[metodo] || SUBTITULO_POR_METODO.native;

  const content = (
    <div
      className="compartilhar-feedback"
      role="status"
      aria-live="polite"
      data-testid="compartilhar-feedback"
    >
      <div className="confete-container" aria-hidden="true">
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className="confete"
            style={{
              '--delay': `${i * 0.08}s`,
              '--cor': i % 3 === 0 ? '#56007F' : i % 3 === 1 ? '#FFA52A' : '#9524E0',
              '--x': `${(i % 2 === 0 ? 1 : -1) * (40 + (i * 17) % 110)}px`,
              '--y': `${-(60 + (i * 23) % 90)}px`,
            }}
          />
        ))}
      </div>
      <div className="feedback-card">
        <span className="feedback-icone" aria-hidden="true">🎉</span>
        <div className="feedback-content">
          <p className="feedback-subtitulo">{subtitulo}</p>
          <p className="feedback-mensagem">{mensagem}</p>
        </div>
        <button
          type="button"
          className="feedback-fechar"
          onClick={onFechar}
          aria-label="Fechar"
        >
          ✕
        </button>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
